import axios from 'axios';
// import createAnalytics from '@/plugins/vue-analytics';
import createGTM from '@/plugins/vue-gtm';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import i18n from '@/plugins/vue-i18n';
import * as types from './mutation-types';
import { production } from '../../environment';

export default {
  load,
  sendQuestion,
  loadTranslations,
};

// ////////////////////////////////////////////
export function load({ commit, state, dispatch }, { order, theme, lang }) {
  if (state.order === order) {
    return Promise.resolve(state.project);
  }

  return axios
    .get(apiEndpoint(order, lang), { headers: authHeader })
    .then(({ data: { data: project } }) => {
      commit(
        types.LOAD,
        { order, project, theme },
      );

      if (production && !window.google_tag_manager) {
        createGTM(project.google_analytics_id);
      }

      if (/[0-9a-f]{15,}/.exec(project.linkedin_link)) {
        // eslint-disable-next-line no-underscore-dangle
        this._vm.$analytics.fbq.init(project.linkedin_link);
        // eslint-disable-next-line no-underscore-dangle
        this._vm.$analytics.fbq.event('PageView');
      }

      if (Array.isArray(project.sunstudy)) {
        dispatch('sunstudy/load', project.sunstudy, { root: true });
      }

      return project;
    });
}

export function sendQuestion({ commit, getters, rootGetters }, { order, form, favouriteUnits }) {
  const {
    form_post_destination: externalDestination,
    name: projectName,
  } = getters.project;
  const { name: unitName } = rootGetters['units/currentUnit'] || {};
  const contactFormFieldsAllowed = rootGetters['service/contactFormFieldsAllowed'];
  const data = Object.assign(
    {
      unitName,
      name: form.name,
      email: form.email,
      phone: form.phone,
      units: JSON.stringify(favouriteUnits || []),
      referer: window.location.href,
      consent: new Date().toJSON(),
    },
    contactFormFieldsAllowed.message && { message: form.message },
    contactFormFieldsAllowed.zip && { zip: form.zip },
    contactFormFieldsAllowed.birthyear && { birthyear: form.birthyear },
  );

  if (externalDestination) {
    try {
      axios.post(externalDestination, {
        ...data,
        projectName,
        projectId: getters.order,
      });
    } catch (e) {
      console.error('External contact form posting error', e);
    }
  }

  return axios
    .post(postQuestionApiEndpoint(order, 'send'), data, { headers: authHeader })
    .then((res) => {
      commit(types.SEND_QUESTION);

      return res && res.data;
    });
}

export function loadTranslations({ commit, state }, order) {
  if (state.i18nTranslations) {
    return Promise.resolve(state.i18nTranslations);
  }

  return axios
    .get(translationsApiEndpoint(order), { headers: authHeader })
    .then(({ data: { data } }) => {
      commit(types.LOAD_TRANSLATIONS, data);

      const langId = state.project.languages.length
        ? state.project.languages[0].language_id.toLowerCase()
        : 'swe';
      const messages = data
        .filter(translation => translation.locale.toLowerCase() === langId)
        .reduce(
          (res, { key, value }) => Object.assign(res, { [key]: value }),
          {},
        );

      i18n.setLocaleMessage(langId, messages);
      i18n.locale = langId;

      return data;
    });
}

function apiEndpoint(order, lang) {
  return production
    ? apiEndpointConst(order, 'project', lang ? `?lang=${lang}` : '')
    : `/api-proxy/${order}/data/project${lang ? `?lang=${lang}` : ''}`;
}

function translationsApiEndpoint(order) {
  return production
    ? apiEndpointConst(order, 'translation', '')
    : `/api-proxy/${order}/data/translation`;
}

function postQuestionApiEndpoint(order) {
  return production
    ? apiEndpointConst(order, 'send', '')
    : `/api-proxy/${order}/data/send`;
}

